class Signature {
	constructor(config) {
		this.config = Object.assign({
			scope: '',
			color: '#444',
			lineWidth: 1.5,
			lineCap: 'round',
		}, config);
		this.$scope = $(this.config.scope);
		if (this.$scope.length > 0) {
			this.init();
		}
	}
	init() {
		this.canvas = this.$scope[0];
		this.setCanvasSize();
		let observer = new ResizeObserver(this.setCanvasSizeWithDebounce.bind(this));
		observer.observe(this.$scope[0]);
		this.context = this.canvas.getContext("2d");
		this.context.strokeStyle = this.config.color;
		this.context.lineWidth = this.config.lineWidth;
		this.context.lineCap = this.config.lineCap;
		this.disableSave = true;
		this.pixels = [];
		this.cpixels = [];
		this.xyLast = {};
		this.xyAddLast = {};
		this.calculate = false;
		let value = this.$scope.attr('data-value');
		if (value) {
			this.setValue(value);
		}
		this.$scope.on('touchstart', this._on_mousedown.bind(this))
		this.$scope.on('mousedown', this._on_mousedown.bind(this))
	}
	setCanvasSizeWithDebounce() {
		this.timeout ? clearTimeout(this.timeout) : null;
		this.timeout = setTimeout(() => this.setCanvasSize(), 200);
	}
	setCanvasSize() {
		this.canvas.width = this.$scope.outerWidth();
		this.canvas.height = this.$scope.outerHeight();
		this.setValue(this.$scope.attr('data-value'), false);
	}
	clear() {
		if (!this.context) {
			return;
		}
		this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
	}
	setValue(value, triggerChangeEvent = true) {
		this.clear();
		if (!value) {
			return;
		}
		let image = new Image();
		image.onload = () => {
			this.context.drawImage(image, 0, 0)
		};
		image.src = value;
		if (triggerChangeEvent) {
			this.triggerChangeEvent();
		}
	}
	getValue() {
		return this.canvas.toDataURL("image/png")
	}
	triggerChangeEvent() {
		this.$scope.trigger('signature:change', {
			value: this.getValue()
		})
	}
	_remove_event_listeners() {
		this.$scope.off('.signature');
		$(document).off('.signature');
	}
	_get_coords(e) {
		var x, y;
		if (e.changedTouches && e.changedTouches[0]) {
			// Gebruik getBoundingClientRect voor betere iOS compatibiliteit
			const rect = this.canvas.getBoundingClientRect();
			x = e.changedTouches[0].clientX - rect.left;
			y = e.changedTouches[0].clientY - rect.top;
		} else if (e.layerX || 0 == e.layerX) {
			x = e.layerX;
			y = e.layerY;
		} else if (e.offsetX || 0 == e.offsetX) {
			x = e.offsetX;
			y = e.offsetY;
		}
		return {
			x: x, y: y
		};
	};
	_on_mousedown(e) {
		e.preventDefault();
		e.stopPropagation();
		this.$scope.on('mouseup.signature', this._on_mouseup.bind(this));
		this.$scope.on('mousemove.signature', this._on_mousemove.bind(this));
		this.$scope.on('touchend.signature', this._on_mouseup.bind(this));
		this.$scope.on('touchmove.signature', this._on_mousemove.bind(this));
		$(document).on('mouseup.signature', this._on_mouseup.bind(this));
		$(document).on('touchend.signature', this._on_mouseup.bind(this));
		var xy = this._get_coords(e);
		this.context.beginPath();
		this.pixels.push('moveStart');
		this.context.moveTo(xy.x, xy.y);
		this.pixels.push(xy.x, xy.y);
		this.xyLast = xy;
	};
	_on_mousemove(e, finish) {
		e.preventDefault();
		e.stopPropagation();
		var xy = this._get_coords(e);
		var xyAdd = {
			x: (this.xyLast.x + xy.x) / 2,
			y: (this.xyLast.y + xy.y) / 2
		};
		if (this.calculate) {
			var xLast = (this.xyAddLast.x + this.xyLast.x + xyAdd.x) / 3;
			var yLast = (this.xyAddLast.y + this.xyLast.y + xyAdd.y) / 3;
			this.pixels.push(xLast, yLast);
		} else {
			this.calculate = true;
		}
		this.context.quadraticCurveTo(this.xyLast.x, this.xyLast.y, xyAdd.x, xyAdd.y);
		this.pixels.push(xyAdd.x, xyAdd.y);
		this.context.stroke();
		this.context.beginPath();
		this.context.moveTo(xyAdd.x, xyAdd.y);
		this.xyAddLast = xyAdd;
		this.xyLast = xy;
	};
	_on_mouseup(e) {
		this._remove_event_listeners();
		this.disableSave = false;
		this.context.stroke();
		this.pixels.push('e');
		this.calculate = false;
		this.triggerChangeEvent();
	};
}
export default Signature;